import React from 'react';

export const RocketIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.73596 16.2859H6.93742C5.96362 16.2859 5.36213 15.2236 5.86314 14.3885L7.75325 11.2383C8.20608 10.4836 9.02167 10.0219 9.9018 10.0219H15.0604M9.73596 16.2859L14.7472 21.2971M9.73596 16.2859L15.0604 10.0219M14.7472 21.2971V24.0957C14.7472 25.0695 15.8095 25.671 16.6446 25.17L19.7947 23.2798C20.5495 22.827 21.0112 22.0114 21.0112 21.1313V15.9727M14.7472 21.2971L21.0112 15.9727M21.0112 15.9727C24.45 12.8205 26.8401 9.40603 27.2217 5.00971C27.2815 4.3204 26.7127 3.75157 26.0234 3.81141C21.6271 4.19304 18.2126 6.58306 15.0604 10.0219M7.23034 26.3084H4.72472V23.8028C4.72472 22.4189 5.84652 21.2971 7.23034 21.2971C8.61415 21.2971 9.73596 22.4189 9.73596 23.8028C9.73596 25.1866 8.61415 26.3084 7.23034 26.3084Z"
      stroke="#002266"
      strokeWidth="2.50562"
      strokeLinejoin="round"
    />
  </svg>
);
